import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Archive from "./pages/Archive";

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route path="/archive">
          <Archive />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
}
